<template>
	<div>
		<div class="xs-12 fs4 fw7 mt6 mb2">
			Please complete all applicable sub-sections that apply to the Individual
			Participant’s Source of Wealth. At least one sub-section should be
			completed . We reserve the right to request additional information and
			documentation with respect to Source of Wealth responses
		</div>
		<case-form :schema="overview" />
		<div class="xs-12 fs4 fw7 mt6 mb2">
			Proceeds from Investment Returns/Private Investor (NOTE: If Investment
			funds are the result of business profit, sale of business, salary, or
			inheritance, please complete the appropriate sections.)
		</div>
		<j-accordion
			v-for="i in 4"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">Details</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaInvestment(i)" :isBoxed="false" />
			</div>
		</j-accordion>
		<case-form :schema="schemaInvestmentOthers" />
		<div class="xs-12 fs4 fw7 mt6 mb2">Salary/Bonus</div>
		<case-form :schema="schemaSalary" />
		<div class="xs-12 fs4 fw7 mt6 mb2">Business Income</div>
		<case-form :schema="schemaBusiness" />
		<div class="xs-12 fs4 fw7 mt6 mb2">Company Sale</div>
		<case-form :schema="schemaCompany" />
		<div class="xs-12 fs4 fw7 mt6 mb2">Rental Income</div>
		<j-accordion
			v-for="i in 3"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">Details</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaRental(i)" :isBoxed="false" />
			</div>
		</j-accordion>
		<div class="xs-12 fs4 fw7 mt6 mb2">Sale of Property(ies)</div>
		<j-accordion
			v-for="i in 2"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">Details</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaProperty(i)" :isBoxed="false" />
			</div>
		</j-accordion>
		<div class="xs-12 fs4 fw7 mt6 mb2">Inheritance or Gift</div>
		<case-form :schema="schemaInheritance" />
		<div class="xs-12 fs4 fw7 mt6 mb2">Other Source of Wealth</div>
		<case-form :schema="schemaOtherSource" />
		<div class="xs-12 fs4 fw7 mt6 mb2">Legal Guardian</div>
		<case-form :schema="schemaGuardian" />
		<div class="xs-12 fs4 fw7 mt6 mb2">Special Instructions</div>
		<case-form :schema="schemaSpecialInstructions" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion/"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	data() {
		return {}
	},

	computed: {
		overview() {
			return [
				{
					label:
						"Proceeds from Investment Returns/Private Investor – If checked go to Section A",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderhasProceedsFromInvestment`,
					props: {
						suggest: {
							typeIncludes: `hasProceedsFromInvestment`
						},
						createOptions: {
							type: `hasProceedsFromInvestment`,
							dataType: "boolean",
							defaultValue: false
						}
					}
				},
				{
					label: "Salary/Bonus – If checked go to Section B",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderhasSalaryOrBonus`,
					props: {
						suggest: {
							typeIncludes: `hasSalaryOrBonus`
						},
						createOptions: {
							type: `hasSalaryOrBonus`,
							dataType: "boolean",
							defaultValue: false
						}
					}
				},
				{
					label: "Business Income/Profits – If checked go to Section C",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderhasBusinessIncome`,
					props: {
						suggest: {
							typeIncludes: `hasBusinessIncome`
						},
						createOptions: {
							type: `hasBusinessIncome`,
							dataType: "boolean",
							defaultValue: false
						}
					}
				},
				{
					label: "Company sale – If checked go to Section D",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderhasCompanySale`,
					props: {
						suggest: {
							typeIncludes: `hasCompanySale`
						},
						createOptions: {
							type: `hasCompanySale`,
							dataType: "boolean",
							defaultValue: false
						}
					}
				},
				{
					label: "Rental income – If checked go to Section E",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderhasRentalIncome`,
					props: {
						suggest: {
							typeIncludes: `hasRentalIncome`
						},
						createOptions: {
							type: `hasRentalIncome`,
							dataType: "boolean",
							defaultValue: false
						}
					}
				},
				{
					label: "Sale of Property – If checked go to Section F",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderhasSaleOfProperty`,
					props: {
						suggest: {
							typeIncludes: `hasSaleOfProperty`
						},
						createOptions: {
							type: `hasSaleOfProperty`,
							dataType: "boolean",
							defaultValue: false
						}
					}
				},
				{
					label: "Inheritance or Gift – If checked go to Section G",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderhasInheritanceOrGift`,
					props: {
						suggest: {
							typeIncludes: `hasInheritanceOrGift`
						},
						createOptions: {
							type: `hasInheritanceOrGift`,
							dataType: "boolean",
							defaultValue: false
						}
					}
				},
				{
					label: "Other Source of Wealth – If checked go to Section H",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderhasOtherSourceOfWealth`,
					props: {
						suggest: {
							typeIncludes: `hasOtherSourceOfWealth`
						},
						createOptions: {
							type: `hasOtherSourceOfWealth`,
							dataType: "boolean",
							defaultValue: false
						}
					}
				}
			]
		},
		schemaInvestmentOthers() {
			return [
				{
					label: `Please provide an explanation for the Source of Wealth used to fund the above investment.`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderinvestmentProceedExplanation`,
					props: {
						suggest: {
							typeIncludes: `investmentProceedExplanation`
						},
						createOptions: {
							type: `investmentProceedExplanation`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaSalary() {
			return [
				{
					label: `Name of Employer`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderemployerName`,
					props: {
						suggest: {
							typeIncludes: `employerName`
						},
						createOptions: {
							type: `employerName`,
							dataType: "string"
						}
					}
				},
				{
					label: `Employer’s Address`,
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.holder.addresses",
					bindTo: `case.facts.holderemployerAddress`,
					props: {
						suggest: {
							typeIncludes: `employerAddress`
						},
						createOptions: {
							type: `employerAddress`,
							dataType: "string"
						}
					}
				},
				{
					label: `Nature of Business`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderemployerNatureOfBusiness`,
					props: {
						suggest: {
							typeIncludes: `employerNatureOfBusiness`
						},
						createOptions: {
							type: `employerNatureOfBusiness`,
							dataType: "string"
						}
					}
				},
				{
					label: `Title/Occupation (If retired, please indicate last occupation .)`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderoccupationPositionAndDuties`,
					props: {
						suggest: {
							typeIncludes: `occupationPositionAndDuties`
						},
						createOptions: {
							type: `occupationPositionAndDuties`,
							dataType: "string"
						}
					}
				},
				{
					label: `Length of Employment or Occupation`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderlengthOfEmployment`,
					props: {
						suggest: {
							typeIncludes: `lengthOfEmployment`
						},
						createOptions: {
							type: `lengthOfEmployment`,
							dataType: "string"
						}
					}
				},
				{
					label: `Annual Salary (USD) `,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderannualSalary`,
					props: {
						suggest: {
							typeIncludes: `annualSalary`
						},
						createOptions: {
							type: `annualSalary`,
							dataType: "number"
						}
					}
				},
				{
					label: `Average Annual Bonus (USD) `,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderaverageAnnualBonus`,
					props: {
						suggest: {
							typeIncludes: `averageAnnualBonus`
						},
						createOptions: {
							type: `averageAnnualBonus`,
							dataType: "number"
						}
					}
				}
			]
		},
		schemaBusiness() {
			return [
				{
					label: `Name of Company or Business`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderownedBusinessName`,
					props: {
						suggest: {
							typeIncludes: `ownedBusinessName`
						},
						createOptions: {
							type: `ownedBusinessName`,
							dataType: "string"
						}
					}
				},
				{
					label: `Annual Profit from the Business (USD)`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderownedBusinessAnnualProfit`,
					props: {
						suggest: {
							typeIncludes: `ownedBusinessAnnualProfit`
						},
						createOptions: {
							type: `ownedBusinessAnnualProfit`,
							dataType: "number"
						}
					}
				},
				{
					label: `Business Address`,
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.holder.addresses",
					bindTo: `case.facts.holderownedBusinessAddress`,
					props: {
						suggest: {
							typeIncludes: `ownedBusinessAddress`
						},
						createOptions: {
							type: `ownedBusinessAddress`,
							dataType: "string"
						}
					}
				},
				{
					label: `Website URL`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderownedBusinessWebsiteURL`,
					props: {
						suggest: {
							typeIncludes: `ownedBusinessWebsiteURL`
						},
						createOptions: {
							type: `ownedBusinessWebsiteURL`,
							dataType: "string"
						}
					}
				},
				{
					label: `Nature of the business (Please describe in detail type of business and products or services provided . )`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderownedBusinessNatureOfBusiness`,
					props: {
						suggest: {
							typeIncludes: `ownedBusinessNatureOfBusiness`
						},
						createOptions: {
							type: `ownedBusinessNatureOfBusiness`,
							dataType: "string"
						}
					}
				},
				{
					label: `If the Participant is an owner/principal of the business, how long have you owned or been a principal in the business (years)?`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderownedBusinessDuration`,
					props: {
						suggest: {
							typeIncludes: `ownedBusinessDuration`
						},
						createOptions: {
							type: `ownedBusinessDuration`,
							dataType: "number"
						}
					}
				},
				{
					label: `Country of Incorporation or country under which the Entity is created, organized, or governed.`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderownedBusinessCountry`,
					props: {
						suggest: {
							typeIncludes: `ownedBusinessCountry`
						},
						createOptions: {
							type: `ownedBusinessCountry`,
							dataType: "string"
						}
					}
				},
				{
					label: `Date of Registration`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderownedBusinessRegistrationDate`,
					props: {
						suggest: {
							typeIncludes: `ownedBusinessRegistrationDate`
						},
						createOptions: {
							type: `ownedBusinessRegistrationDate`,
							dataType: "date"
						}
					}
				}
			]
		},
		schemaCompany() {
			return [
				{
					label: `Name of Company that was sold`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holdersoldCompanyName`,
					props: {
						suggest: {
							typeIncludes: `soldCompanyName`
						},
						createOptions: {
							type: `soldCompanyName`,
							dataType: "string"
						}
					}
				},
				{
					label: `Nature of the Company (Business Activities)`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holdersoldCompanyBusinessNature`,
					props: {
						suggest: {
							typeIncludes: `soldCompanyBusinessNature`
						},
						createOptions: {
							type: `soldCompanyBusinessNature`,
							dataType: "string"
						}
					}
				},
				{
					label: `Total Proceeds/Sale Amount`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holdersoldCompanyTotalProceeds`,
					props: {
						suggest: {
							typeIncludes: `soldCompanyTotalProceeds`
						},
						createOptions: {
							type: `soldCompanyTotalProceeds`,
							dataType: "number"
						}
					}
				},
				{
					label: `Client Share in %`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holdersoldCompanyClientShare`,
					props: {
						suggest: {
							typeIncludes: `soldCompanyClientShare`
						},
						createOptions: {
							type: `soldCompanyClientShare`,
							dataType: "number"
						}
					}
				},
				{
					label: `Date of Sale`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holdersoldCompanyDateOfSale`,
					props: {
						suggest: {
							typeIncludes: `soldCompanyDateOfSale`
						},
						createOptions: {
							type: `soldCompanyDateOfSale`,
							dataType: "date"
						}
					}
				}
			]
		},

		schemaInheritance() {
			return [
				{
					label: `Name of the person from whom the funds were inherited or received`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderinheritanceNameOfPerson`,
					props: {
						suggest: {
							typeIncludes: `inheritanceNameOfPerson`
						},
						createOptions: {
							type: `inheritanceNameOfPerson`,
							dataType: "string"
						}
					}
				},
				{
					label: `Relationship to the Participant`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderinheritanceRelationshipToParticipant`,
					props: {
						suggest: {
							typeIncludes: `inheritanceRelationshipToParticipant`
						},
						createOptions: {
							type: `inheritanceRelationshipToParticipant`,
							dataType: "string"
						}
					}
				},
				{
					label: `Source of wealth of the person from whom the funds were inherited or received`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderinheritancePersonSourceOfWealth`,
					props: {
						suggest: {
							typeIncludes: `inheritancePersonSourceOfWealth`
						},
						createOptions: {
							type: `inheritancePersonSourceOfWealth`,
							dataType: "string"
						}
					}
				},
				{
					label: `Total amount of the Gift(s) (USD)`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderinheritanceTotalAmount`,
					props: {
						suggest: {
							typeIncludes: `inheritanceTotalAmount`
						},
						createOptions: {
							type: `inheritanceTotalAmount`,
							dataType: "number"
						}
					}
				},
				{
					label: `Reason for Gift, if applicable`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderinheritanceReason`,
					props: {
						suggest: {
							typeIncludes: `inheritanceReason`
						},
						createOptions: {
							type: `inheritanceReason`,
							dataType: "string"
						}
					}
				},
				{
					label: `Date of Inheritance`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderinheritanceDate`,
					props: {
						suggest: {
							typeIncludes: `inheritanceDate`
						},
						createOptions: {
							type: `inheritanceDate`,
							dataType: "date"
						}
					}
				},
				{
					label: `Name of Attorney/Solicitor who can confirm the inheritance or gift`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderinheritanceNameOfSolicitor`,
					props: {
						suggest: {
							typeIncludes: `inheritanceNameOfSolicitor`
						},
						createOptions: {
							type: `inheritanceNameOfSolicitor`,
							dataType: "string"
						}
					}
				},
				{
					label: `Contact information of Attorney/Solicitor (Business address, telephone number and email address)`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderinheritanceSolicitorContactInformation`,
					props: {
						suggest: {
							typeIncludes: `inheritanceSolicitorContactInformation`
						},
						createOptions: {
							type: `inheritanceSolicitorContactInformation`,
							dataType: "string"
						}
					}
				}
			]
		},
		schemaOtherSource() {
			return [
				{
					label: `Please describe in complete detail`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderotherSourceOfWealthDetails`,
					props: {
						suggest: {
							typeIncludes: `otherSourceOfWealthDetails`
						},
						createOptions: {
							type: `otherSourceOfWealthDetails`,
							dataType: "string"
						}
					}
				}
			]
		},
		schemaGuardian() {
			return [
				{
					label: `Proceeds to be paid to - Name of Legal Guardian*`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderlegalGuardianName`,
					props: {
						suggest: {
							typeIncludes: `legalGuardianName`
						},
						createOptions: {
							type: `legalGuardianName`,
							dataType: "string"
						}
					}
				},
				{
					label: `Date of Birth`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderlegalGuardianDateofBirth`,
					props: {
						suggest: {
							typeIncludes: `legalGuardianDateofBirth`
						},
						createOptions: {
							type: `legalGuardianDateofBirth`,
							dataType: "date"
						}
					}
				},
				{
					label: `Guardian for`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderlegalGuardianFor`,
					props: {
						suggest: {
							typeIncludes: `legalGuardianFor`
						},
						createOptions: {
							type: `legalGuardianFor`,
							dataType: "string"
						}
					}
				},
				{
					label: `Address`,
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.holder.addresses",
					bindTo: `case.facts.holderlegalGuardianAddress`,
					props: {
						suggest: {
							typeIncludes: `legalGuardianAddress`
						},
						createOptions: {
							type: `legalGuardianAddress`,
							dataType: "string"
						}
					}
				},
				{
					label: `Is any Legal Guardian listed above a PEP or a close relative of a PEP (Politically Exposed Person)? `,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderlegalGuardianIsPEP`,
					props: {
						suggest: {
							typeIncludes: `legalGuardianIsPEP`
						},
						createOptions: {
							type: `legalGuardianIsPEP`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `If "Yes", please provide Legal Guardian name, title/rank, and details or duties, or if a relative of a PEP, provide the nature of the Relatioship with the PEP`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderlegalGuardianPEPDetails`,
					props: {
						suggest: {
							typeIncludes: `legalGuardianPEPDetails`
						},
						createOptions: {
							type: `legalGuardianPEPDetails`,
							dataType: "string"
						}
					}
				}
			]
		},
		schemaSpecialInstructions() {
			return [
				{
					label: ``,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderspecialInstructions`,
					props: {
						suggest: {
							typeIncludes: `specialInstructions`
						},
						createOptions: {
							type: `specialInstructions`,
							dataType: "string"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaInvestment(i) {
			return [
				{
					label: `Name	of	Firm	where	you	invest`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderinvestmentProceedNameOfFirm${i}`,
					props: {
						suggest: {
							typeIncludes: `investmentProceedNameOfFirm${i}`
						},
						createOptions: {
							type: `investmentProceedNameOfFirm${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Location Of Firm`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderinvestmentProceedLocationOfFirm${i}`,
					props: {
						suggest: {
							typeIncludes: `investmentProceedLocationOfFirm${i}`
						},
						createOptions: {
							type: `investmentProceedLocationOfFirm${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `How long have you held an account at this firm?`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderinvestmentProceedAccountDuration${i}`,
					props: {
						suggest: {
							typeIncludes: `investmentProceedAccountDuration${i}`
						},
						createOptions: {
							type: `investmentProceedAccountDuration${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Average account blanace (USD)`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderinvestmentProceedAccountAverage${i}`,
					props: {
						suggest: {
							typeIncludes: `investmentProceedAccountAverage${i}`
						},
						createOptions: {
							type: `investmentProceedAccountAverage${i}`,
							dataType: "number"
						}
					}
				},
				{
					label: `Category of Investment`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderinvestmentProceedInvestmentCategory${i}`,
					props: {
						suggest: {
							typeIncludes: `investmentProceedInvestmentCategory${i}`
						},
						createOptions: {
							type: `investmentProceedInvestmentCategory${i}`,
							dataType: "string"
						}
					}
				}
			]
		},
		schemaRental(i) {
			return [
				{
					label: `Address of Property`,
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.holder.addresses",
					bindTo: `case.facts.holderrentalPropertyAddress${i}`,
					props: {
						suggest: {
							typeIncludes: `rentalPropertyAddress${i}`
						},
						createOptions: {
							type: `rentalPropertyAddress${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Property Type: Single Residential`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderrentalPropertyForSingle${i}`,
					props: {
						suggest: {
							typeIncludes: `rentalPropertyForSingle${i}`
						},
						createOptions: {
							type: `rentalPropertyForSingle${i}`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Property Type: Multi-unit Residential`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderrentalPropertyForMulti${i}`,
					props: {
						suggest: {
							typeIncludes: `rentalPropertyForMulti${i}`
						},
						createOptions: {
							type: `rentalPropertyForMulti${i}`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Property Type: Commercial Residential`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderrentalPropertyForCommercial${i}`,
					props: {
						suggest: {
							typeIncludes: `rentalPropertyForCommercial${i}`
						},
						createOptions: {
							type: `rentalPropertyForCommercial${i}`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Annual rental income (USD)`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderrentalPropertyIncome${i}`,
					props: {
						suggest: {
							typeIncludes: `rentalPropertyIncome${i}`
						},
						createOptions: {
							type: `rentalPropertyIncome${i}`,
							dataType: "number"
						}
					}
				}
			]
		},
		schemaProperty(i) {
			return [
				{
					label: `Address of Property Sold`,
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.holder.addresses",
					bindTo: `case.facts.holdersoldPropertyAddress${i}`,
					props: {
						suggest: {
							typeIncludes: `holdersoldPropertyAddress${i}`
						},
						createOptions: {
							type: `holdersoldPropertyAddress${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Please provide an explanation for the Source of Wealth used to purchase the above property?`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holdersoldPropertyExplanation${i}`,
					props: {
						suggest: {
							typeIncludes: `soldPropertyExplanation${i}`
						},
						createOptions: {
							type: `soldPropertyExplanation${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Date of Sale`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holdersoldPropertyDateOfSale${i}`,
					props: {
						suggest: {
							typeIncludes: `soldPropertyDateOfSale${i}`
						},
						createOptions: {
							type: `soldPropertyDateOfSale${i}`,
							dataType: "date"
						}
					}
				},
				{
					label: `Total Sale Amount`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holdersoldPropertyTotalAmount${i}`,
					props: {
						suggest: {
							typeIncludes: `soldPropertyTotalAmount${i}`
						},
						createOptions: {
							type: `soldPropertyTotalAmount${i}`,
							dataType: "number"
						}
					}
				}
			]
		}
	},

	created() {}
}
</script>
